import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../Modal/modal.css';
import { API_URL, MS_URL } from '../../../utils/Constants'


const Preview = () => {

    document.body.style.backgroundImage = "none";
    document.body.style.backgroundRepeat = "no-repeat";

    const [srcUrl, setSrcUrl] = useState('');
    const [error, setError] = useState('');
    const location = useLocation();

    useEffect(() => {
        let isMounted = true;
        let objectUrl = '';
        const controller = new AbortController();

        const loadPreview = async () => {
            setError('');
            setSrcUrl('');

            const customToken = localStorage.getItem('accessToken');
            if (!customToken) {
                setError('Preview unavailable. Please sign in again.');
                window.location.href = MS_URL;
                return;
            }

            const filepath = (location.pathname).replace('/mdc/preview/','/');
            const url = `${API_URL}/mdc/preview${filepath}`;

            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': `Bearer ${customToken}`
                    },
                    signal: controller.signal
                });

                if (!response.ok) {
                    if (response.status === 401) {
                        localStorage.removeItem("accessToken");
                        localStorage.removeItem("clientId");
                        localStorage.removeItem("userOid");
                        localStorage.removeItem("userTid");
                        sessionStorage.clear();
                        localStorage.clear();
                        window.location.href = MS_URL;
                        return;
                    }
                    if (response.status === 403) {
                        setError('Access denied. You do not have permission to preview this file.');
                        return;
                    }
                    setError('This file cannot be previewed as it has been soft deleted. Please review the soft deleted files list to locate and restore it.');
                    return;
                }

                const blob = await response.blob();
                objectUrl = URL.createObjectURL(blob);

                if (isMounted) {
                    setSrcUrl(objectUrl);
                }
            } catch (err) {
                if (err.name !== 'AbortError') {
                    setError('Unable to preview this file.');
                }
            }
        };

        loadPreview();

        return () => {
            isMounted = false;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
            controller.abort();
        };
      }, [location.pathname])





    return(
        <div className="modal-content-table" > 

            <div id="preview_file" className='unzip-table'>
                {error ? (
                    <div className="preview-error">{error}</div>
                ) : (
                    <iframe src = {srcUrl} className='preview-iframe' />
                )}
            </div>
        </div>
    );

}

export default Preview
